import React, { useEffect, useState } from "react";
import styles from "./Card.module.css";
import heart from "../../assets/images/svg/heart.svg";
import stars from "../../assets/images/svg/stars.svg";
import fallbackProductImage from "../../assets/images/svg/product-placeholder-card.svg";
import "@emran-alhaddad/saudi-riyal-font/index.css";

const Card = ({
  title,
  para,
  image,
  pricebefore,
  priceafter,
  sale,
  name,
  currency,
  brand,
  brandLogo,
  variant = "default",
}) => {
  const [imageSrc, setImageSrc] = useState(image || fallbackProductImage);
  const numericPriceBefore = Number(pricebefore) || 0;
  const numericPriceAfter = Number(priceafter) || 0;
  const isFeatured = variant === "featured";
  const isListing = variant === "listing";

  useEffect(() => {
    setImageSrc(image || fallbackProductImage);
  }, [image]);

  const hasDiscount =
    numericPriceBefore > 0 &&
    numericPriceAfter > 0 &&
    numericPriceBefore > numericPriceAfter;

  if (hasDiscount) {
    sale = Math.round(
      ((numericPriceBefore - numericPriceAfter) / numericPriceBefore) * 100,
    );
  } else {
    sale = 0;
  }

  const displayPrice = numericPriceAfter || numericPriceBefore;
  const secondaryPrice = numericPriceBefore && numericPriceBefore !== displayPrice
    ? numericPriceBefore
    : 0;
  const saleLabel = isFeatured || isListing ? `-${sale}%` : `${sale}%`;
  const currencyText =
    currency && !["SAR", "ر.س", "ريال", "ريال سعودي"].includes(currency)
      ? currency
      : "";
  const renderCurrency = () =>
    currencyText ? (
      <span className={styles.currencyText}>{currencyText}</span>
    ) : (
      <span className="icon-saudi_riyal"></span>
    );

  return (
    <div
      className={`${styles.cardProduct} ${isFeatured ? styles.featuredCard : ""} ${
        isListing ? styles.listingCard : ""
      }`}
      onClick={() => (window.location.href = "/product/" + name)}
    >
      <div className={styles.cardHeader}>
        {sale !== 0 ? (
          <h2 className={styles.saleBadge}>{saleLabel}</h2>
        ) : (
          <div className={styles.saleSpacer}></div>
        )}
        {isFeatured ? (
          <div className={styles.brandSlot}>
            {brandLogo ? (
              <img src={brandLogo} alt={brand || ""} />
            ) : brand ? (
              <span>{brand}</span>
            ) : null}
          </div>
        ) : (
          <div>
            <img src={heart} alt="" />
          </div>
        )}
      </div>
      <div className={styles.cardImg}>
        <img
          src={imageSrc}
          alt={title}
          loading="lazy"
          decoding="async"
          onError={() => setImageSrc(fallbackProductImage)}
        />
      </div>
      <div className={styles.cardContent}>
        <h1>{title}</h1>
        <p>{para}</p>
        <img src={stars} alt="" />
        {/* <div className="price">
                    <h3>{pricebefore}<span>{currency}</span></h3> <h3>-</h3> <h3>{priceafter}<span>{currency}</span></h3>
                </div> */}
        {isFeatured ? (
          <div className={styles.featuredPrice}>
            <p>
              <span>{displayPrice}</span>
              {renderCurrency()}
              {secondaryPrice !== 0 && (
                <>
                  <span className={styles.priceDash}>-</span>
                  <span>{secondaryPrice}</span>
                  {renderCurrency()}
                </>
              )}
            </p>
          </div>
        ) : (
          <div className={styles.priceRow}>
            <div className={styles.afterPrice}>
              <p>
                <span className="icon-saudi_riyal"></span>
                <span>{displayPrice}</span>
              </p>
            </div>
            {hasDiscount && (
              <div className={styles.beforePrice}>
                <p>
                  <span className="icon-saudi_riyal"></span>
                  <span>{numericPriceBefore}</span>
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;
